import React from 'react'
import { Modal } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import '../modal.css'

interface ChangeCharacterModalProps {
  show: boolean
  onHide: () => void
  fromCharacter: string
  toCharacter: string
  onConfirm: (character: string) => void
  isUpdating?: boolean
}

const ChangeCharacterModal: React.FC<ChangeCharacterModalProps> = ({
  show,
  onHide,
  fromCharacter,
  toCharacter,
  onConfirm,
  isUpdating = false,
}) => {
  const { t } = useTranslation('settings')
  const handleClose = () => {
    if (!isUpdating) {
      onHide()
    }
  }

  return (
    <div className='custom_modal'>
      <Modal
        show={show}
        onHide={handleClose}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        className='common_modal_main_div'
        backdrop={isUpdating ? 'static' : true}
        keyboard={!isUpdating}
      >
        <Modal.Body className='mobile_align_div'>
          <div className='modal_title_div'>
            <h4 className='modal_heading'>{t('characters.changeModal.title')}</h4>
          </div>
          <div className='downgrade-modal-content'>
            <div className='m-al-c'>{t('characters.changeModal.question')}</div>
            <div className='m-al-c'>
              <Trans
                t={t}
                i18nKey='characters.changeModal.fromTo'
                values={{ from: fromCharacter.toUpperCase(), to: toCharacter.toUpperCase() }}
                components={{
                  from: <span className={`level-${fromCharacter.toLowerCase()}`} />,
                  to: <span className={`level-${toCharacter.toLowerCase()}`} />,
                }}
              />
            </div>
          </div>
          <div className='downgrade-modal-buttons'>
            <button className='btn btn-outline-secondary' onClick={onHide} disabled={isUpdating}>
              {t('characters.changeModal.cancel')}
            </button>
            <button
              className='btn btn-success downgrade-confirm-btn'
              onClick={() => onConfirm(toCharacter)}
              disabled={isUpdating}
            >
              {isUpdating ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                  {t('characters.changeModal.changing')}
                </>
              ) : (
                t('characters.changeModal.confirm')
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ChangeCharacterModal
